<template>
  <div id="health-insurance">
    <vice-title>
      <h3>{{ this.$t("lang.BetterMedicalCare.healthInsurance") }}</h3>
    </vice-title>
    <div class="health-insurance">
      <el-row :gutter="86">
        <el-col :span="8"
          ><div class="insurance-item">
            <p class="item-icon">
              <svg class="icon" aria-hidden="true">
                <use xlink:href="#icon-tijianbaogao"></use>
              </svg>
            </p>
            <h3 :class="languageTitle">
              {{ this.$t("lang.BetterMedicalCare.insuranceConsultants") }}
            </h3>
            <p :class="languageContent">
              {{ this.$t("lang.BetterMedicalCare.insuranceConsultantsDetail") }}
            </p>
          </div></el-col
        >
        <el-col :span="8"
          ><div class="insurance-item">
            <p class="item-icon">
              <svg class="icon" aria-hidden="true">
                <use xlink:href="#icon-jiankangguanli"></use>
              </svg>
            </p>
            <h3 :class="languageTitle">
              {{ this.$t("lang.BetterMedicalCare.characterized") }}
            </h3>
            <p :class="languageContent">
              {{ this.$t("lang.BetterMedicalCare.characterizedDetail") }}
            </p>
          </div></el-col
        >
        <el-col :span="8"
          ><div class="insurance-item">
            <p class="item-icon">
              <svg class="icon" aria-hidden="true">
                <use xlink:href="#icon-yuyueguahao"></use>
              </svg>
            </p>
            <h3 :class="languageTitle">
              {{ this.$t("lang.BetterMedicalCare.iPay") }}
            </h3>
            <p :class="languageContent">
              {{ this.$t("lang.BetterMedicalCare.iPayDetail") }}
            </p>
          </div></el-col
        >
      </el-row>
    </div>
  </div>
</template>

<script>
import ViceTitle from "../ViceTitle";
export default {
  name: "HealthInsurance",
  components: {
    ViceTitle
  },
  data() {
    return {
      languageTitle: "",
      languageContent: ""
    };
  },
  mounted() {
    this.setStyle();
  },
  beforeUpdate() {
    this.setStyle();
  },
  methods: {
    setStyle() {
      if (this.$i18n.locale === "en-US") {
        this.languageTitle = "item-title-us";
        this.languageContent = "item-content-us";
      } else if (this.$i18n.locale === "zh-CN") {
        this.languageTitle = "item-title-us";
        this.languageContent = "item-content-us";
      }
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../../assets/styles/global";
#health-insurance {
  width: 75%;
  margin: 0 auto;
  overflow: hidden;
  .health-insurance {
    width: 898px;
    margin: 40px auto;
    .insurance-item {
      height: 238px;
      box-shadow: -2px 7px 19px 2px rgba(130, 195, 255, 0.14);
      text-align: center;
      overflow: hidden;
      .item-icon {
        margin-top: 22px;
      }
      .item-title {
        margin-top: 22px;
        font-size: 20px;
        color: $publicBlue;
      }
      .item-title-us {
        margin-top: 22px;
        font-size: 16px;
        color: $publicBlue;
      }
      .item-content {
        word-break: break-all;
        margin: 22px 15px;
        text-align: left;
        line-height: 20px;
        color: #9e9e9e;
        font-size: 16px;
      }
      .item-content-us {
        word-break: break-all;
        margin: 22px 15px;
        text-align: left;
        line-height: 20px;
        color: #9e9e9e;
        font-size: 14px;
      }
    }
  }
  .health-image {
    height: 560px;
    margin: 50px auto;
    img {
      width: 100%;
      height: 100%;
    }
  }
}
.icon {
  width: 50px;
  height: 50px;
  vertical-align: -0.15em;
  fill: currentColor;
  overflow: hidden;
}
</style>
